import React, {useEffect, useState} from 'react';
import {PlayerListWrapper} from './styles';
import {FluidContainer, TeamsListTable} from '../../../components';

export default ({teamMemo, inputValue}) => {
  const [table, useTable] = useState([...teamMemo]);
  useEffect(() => {
    useTable([...teamMemo.filter(el => el.name.toLowerCase().includes(inputValue.value.toLowerCase()))]);
  }, [inputValue, teamMemo]);
  return (
    <PlayerListWrapper>
      <FluidContainer overflow={true}>
        <TeamsListTable dataCy="player-list" minWidth="800px" dataTableContent={table} />
      </FluidContainer>
    </PlayerListWrapper>
  );
};
